import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { Header } from "../Header/Header";
import { MainMenu } from "../MainMenu/MainMenu";
import { RoleType } from "../../models/Role";
import { ErrorFallback } from "../../components/ErrorFallback/ErrorFallback";
import { activeUser, removeActiveUser } from "../../services/AuthServices";
import "./PageLayout.scss";
import { MenuOutlined } from "@ant-design/icons";

export interface PageLayoutProps {
  children?: React.ReactElement | React.ReactElement[];
}

export const PageLayout = (p: PageLayoutProps) => {
  const navigate = useNavigate();
  const [openNav, setOpenNav] = useState(false);

  const mainMenuDefinitionAdmin = [
    {
      id: 1,
      label: "Događaji",
      icon: "<CarryOutOutlined />",
      open: false,
      items: [
        {
          mainId: 1,
          id: 1,
          label: "Lista događaja",
          command: () => navigate("/event-list"),
        },
        {
          mainId: 1,
          id: 2,
          label: "Novi događaj",
          command: () => navigate("/new-event"),
        },
      ],
    },
    {
      id: 2,
      label: "Učesnici",
      icon: "<UserOutlined />",
      open: false,
      items: [
        {
          mainId: 2,
          id: 1,
          label: "Lista učesnika",
          command: () => navigate("/participant-list"),
        },
        {
          mainId: 2,
          id: 2,
          label: "Lista pravnih lica",
          command: () => navigate("/participant-company-list"),
        },
        {
          mainId: 2,
          id: 3,
          label: "Arhiva učesnika",
          command: () => navigate("/participant-list/inactive"),
        },
      ],
    },
    {
      id: 3,
      label: "Prijave",
      icon: "<ProfileOutlined />",
      open: false,
      items: [
        {
          mainId: 3,
          id: 1,
          label: "Lista prijava",
          command: () => navigate("/registration-list"),
        },
        {
          mainId: 3,
          id: 2,
          label: "Prijavite pravno lice",
          command: () => navigate("/new-registration-company"),
        },
        {
          mainId: 3,
          id: 3,
          label: "Prijavite fizičko lice",
          command: () => navigate("/new-registration"),
        },
      ],
    },
    {
      id: 4,
      label: "Smeštaj",
      icon: "<FileOutlined />",
      open: false,
      items: [
        {
          mainId: 4,
          id: 1,
          label: "Lista smeštaja",
          command: () => navigate("/accommodation-list"),
        },
        {
          mainId: 4,
          id: 2,
          label: "Novi smeštaj",
          command: () => navigate("/new-accommodation"),
        },
      ],
    },
    {
      id: 5,
      label: "Faktura",
      icon: "<FileTextOutlined />",
      open: false,
      items: [
        {
          mainId: 5,
          id: 1,
          label: "Lista profaktura",
          command: () => navigate("/invoice-list"),
        },
        {
          mainId: 5,
          id: 2,
          label: "Arhiva profaktura",
          command: () => navigate("/invoice-archive"),
        },
      ],
    },
    {
      id: 6,
      label: "Obaveštenja",
      icon: "<BellOutlined />",
      open: false,
      command: () => navigate("/notification-list"),
    },
    {
      id: 7,
      label: "Statistike",
      icon: "<DashboardOutlined />",
      open: false,
      items: [
        {
          mainId: 7,
          id: 1,
          label: "Aktuelni događaj",
          command: () => navigate("/current-event"),
        },
        {
          mainId: 7,
          id: 2,
          label: "Završeni događaji",
          command: () => navigate("/finished-events"),
        },
      ],
    },
    {
      id: 8,
      label: "Notifikacije",
      icon: "<NotificationOutlined />",
      open: false,
      command: () => navigate("/notification-participant"),
    },
    {
      id: 9,
      label: "Host događaj",
      icon: "<QrcodeOutlined />",
      open: false,
      command: () => navigate("/host-events"),
    },
    {
      id: 10,
      label: "Galerija",
      icon: "<PictureOutlined />",
      open: false,
      command: () => navigate("/gallery"),
    },
    {
      id: 11,
      label: "Podešavanja",
      icon: "<SettingOutlined />",
      open: false,
      command: () => navigate("/users"),
    },
  ];

  const mainMenuDefinitionAgency = [
    {
      id: 1,
      label: "Događaji",
      icon: "<CarryOutOutlined />",
      open: false,
      items: [
        {
          mainId: 1,
          id: 1,
          label: "Lista događaja",
          command: () => navigate("/event-list"),
        },
      ],
    },
    {
      id: 2,
      label: "Učesnici",
      icon: "<UserOutlined />",
      open: false,
      items: [
        {
          mainId: 2,
          id: 1,
          label: "Lista učesnika",
          command: () => navigate("/participant-list"),
        },
        {
          mainId: 2,
          id: 2,
          label: "Lista pravnih lica",
          command: () => navigate("/participant-company-list"),
        },
      ],
    },
    {
      id: 3,
      label: "Prijave",
      icon: "<ProfileOutlined />",
      open: false,
      items: [
        {
          mainId: 3,
          id: 1,
          label: "Lista prijava",
          command: () => navigate("/registration-list"),
        },
      ],
    },
    {
      id: 4,
      label: "Smeštaj",
      icon: "<FileOutlined />",
      open: false,
      items: [
        {
          mainId: 4,
          id: 1,
          label: "Lista smeštaja",
          command: () => navigate("/accommodation-list"),
        },
        {
          mainId: 4,
          id: 2,
          label: "Novi smeštaj",
          command: () => navigate("/new-accommodation"),
        },
      ],
    },
    {
      id: 5,
      label: "Faktura",
      icon: "<FileTextOutlined />",
      open: false,
      items: [
        {
          mainId: 5,
          id: 1,
          label: "Lista profaktura",
          command: () => navigate("/invoice-list"),
        },
        // {
        //   mainId: 5,
        //   id: 2,
        //   label: "Nova profaktura",
        //   command: () => navigate("/new-invoice"),
        // },
      ],
    },
    {
      id: 6,
      label: "Obaveštenja",
      icon: "<BellOutlined />",
      open: false,
      command: () => navigate("/notification-list"),
    },
  ];

  const mainMenuDefinitionEmployee = [
    {
      id: 1,
      label: "Događaji",
      icon: "<CarryOutOutlined />",
      open: false,
      items: [
        {
          mainId: 1,
          id: 1,
          label: "Lista događaja",
          command: () => navigate("/event-list"),
        },
        {
          mainId: 1,
          id: 2,
          label: "Novi događaj",
          command: () => navigate("/new-event"),
        },
      ],
    },
    {
      id: 2,
      label: "Učesnici",
      icon: "<UserOutlined />",
      open: false,
      items: [
        {
          mainId: 2,
          id: 1,
          label: "Lista učesnika",
          command: () => navigate("/participant-list"),
        },
        {
          mainId: 2,
          id: 2,
          label: "Lista pravnih lica",
          command: () => navigate("/participant-company-list"),
        },
      ],
    },
    {
      id: 3,
      label: "Prijave",
      icon: "<ProfileOutlined />",
      open: false,
      items: [
        {
          mainId: 3,
          id: 1,
          label: "Lista prijava",
          command: () => navigate("/registration-list"),
        },
        {
          mainId: 3,
          id: 2,
          label: "Prijavite pravno lice",
          command: () => navigate("/new-registration-company"),
        },
        {
          mainId: 3,
          id: 3,
          label: "Prijavite fizičko lice",
          command: () => navigate("/new-registration"),
        },
      ],
    },
    {
      id: 4,
      label: "Smeštaj",
      icon: "<FileOutlined />",
      open: false,
      items: [
        {
          mainId: 4,
          id: 1,
          label: "Lista smeštaja",
          command: () => navigate("/accommodation-list"),
        },
        {
          mainId: 4,
          id: 2,
          label: "Novi smeštaj",
          command: () => navigate("/new-accommodation"),
        },
      ],
    },
    {
      id: 5,
      label: "Faktura",
      icon: "<FileTextOutlined />",
      open: false,
      items: [
        {
          mainId: 5,
          id: 1,
          label: "Lista profaktura",
          command: () => navigate("/invoice-list"),
        },
        // {
        //   mainId: 5,
        //   id: 2,
        //   label: "Nova profaktura",
        //   command: () => navigate("/new-invoice"),
        // },
      ],
    },
    {
      id: 6,
      label: "Obaveštenja",
      icon: "<BellOutlined />",
      open: false,
      command: () => navigate("/notification-list"),
    },
  ];

  const mainMenuDefinitionTest = [
    {
      id: 3,
      label: "Prijave",
      icon: "<ProfileOutlined />",
      open: false,
      items: [
        {
          mainId: 3,
          id: 1,
          label: "Lista prijava",
          command: () => navigate("/registration-list"),
        },
        {
          mainId: 3,
          id: 2,
          label: "Prijavite pravno lice",
          command: () => navigate("/new-registration-company"),
        },
        {
          mainId: 3,
          id: 3,
          label: "Prijavite fizičko lice",
          command: () => navigate("/new-registration"),
        },
      ],
    },
  ];

  const mainMenuDefinitionSupervizor = [
    {
      id: 1,
      label: "Događaji",
      icon: "<CarryOutOutlined />",
      open: false,
      items: [
        {
          mainId: 1,
          id: 1,
          label: "Lista događaja",
          command: () => navigate("/event-list"),
        },
        {
          mainId: 1,
          id: 2,
          label: "Novi događaj",
          command: () => navigate("/new-event"),
        },
      ],
    },
    {
      id: 2,
      label: "Učesnici",
      icon: "<UserOutlined />",
      open: false,
      items: [
        {
          mainId: 2,
          id: 1,
          label: "Lista učesnika",
          command: () => navigate("/participant-list"),
        },
        {
          mainId: 2,
          id: 2,
          label: "Lista pravnih lica",
          command: () => navigate("/participant-company-list"),
        },
      ],
    },
    {
      id: 3,
      label: "Prijave",
      icon: "<ProfileOutlined />",
      open: false,
      items: [
        {
          mainId: 3,
          id: 1,
          label: "Lista prijava",
          command: () => navigate("/registration-list"),
        },
        {
          mainId: 3,
          id: 2,
          label: "Prijavite pravno lice",
          command: () => navigate("/new-registration-company"),
        },
        {
          mainId: 3,
          id: 3,
          label: "Prijavite fizičko lice",
          command: () => navigate("/new-registration"),
        },
      ],
    },
    {
      id: 4,
      label: "Smeštaj",
      icon: "<FileOutlined />",
      open: false,
      items: [
        {
          mainId: 4,
          id: 1,
          label: "Lista smeštaja",
          command: () => navigate("/accommodation-list"),
        },
        {
          mainId: 4,
          id: 2,
          label: "Novi smeštaj",
          command: () => navigate("/new-accommodation"),
        },
      ],
    },
    {
      id: 5,
      label: "Faktura",
      icon: "<FileTextOutlined />",
      open: false,
      items: [
        {
          mainId: 5,
          id: 1,
          label: "Lista profaktura",
          command: () => navigate("/invoice-list"),
        },
      ],
    },
    {
      id: 6,
      label: "Obaveštenja",
      icon: "<BellOutlined />",
      open: false,
      command: () => navigate("/notification-list"),
    },
  ];

  let mainMenuDefinition: any = [];

  if (activeUser) {
    switch (activeUser.role?.name) {
      case RoleType.Admin:
        mainMenuDefinition = mainMenuDefinitionAdmin;
        break;
      case RoleType.Agency:
        mainMenuDefinition = mainMenuDefinitionAgency;
        break;
      case RoleType.Employee:
        mainMenuDefinition = mainMenuDefinitionEmployee;
        break;
      case RoleType.Supervizor:
        mainMenuDefinition = mainMenuDefinitionSupervizor;
        break;
      case RoleType.Test:
        mainMenuDefinition = mainMenuDefinitionTest;
        break;
    }
  } else {
    mainMenuDefinition = [];
  }

  const navFunctionToggle = () => {
    setOpenNav(!openNav);
  };

  return (
    <div className="uos-portal-page">
      <div
        className="mobile-nav-button"
        style={{
          position: "absolute",
          top: "15px",
          left: "17px",
          fontSize: "40px",
        }}
        onClick={() => {
          navFunctionToggle();
        }}
      >
        <MenuOutlined />
      </div>
      <div className="uos-portal-page-content">
        <div className="uos-portal-main-menu-wrapper">
          <MainMenu
            menuItemList={mainMenuDefinition}
            openNav={openNav}
            navFunctionToggle={navFunctionToggle}
          />
        </div>
        <div className={`uos-portal-content-wrapper`}>
          <Header
            profileImage=""
            name={`${activeUser?.nameAndSurname}`}
            onNotificationClick={() => navigate("/notification-list")}
            onLogoutClick={() => {
              removeActiveUser();
              navigate(`/`);
            }}
          />
          <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onReset={() => {
              // reset the state of your app so the error doesn't happen again
            }}
          >
            {p.children}
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
};
